import mountDeferredStyles from './mountDeferredStyles';
import { AppWindow } from '../../definitions/AppWindow';

declare let window: AppWindow;

export default function initDeferredStyles() {
  window.addEventListener('DOMContentLoaded', mountDeferredStyles);
}
